import { render, staticRenderFns } from "./AnnotationDescription.vue?vue&type=template&id=77038b54"
import script from "./AnnotationDescription.vue?vue&type=script&lang=js"
export * from "./AnnotationDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports